// Layout.js
import React,{useState} from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import SubHeader from './SubHeader';
import Footer from './Footer';

const Layout = ({ children, title, subtitle }) => {
  const location = useLocation();
  const [dateRange, setDateRange] = useState(null);

  const isLoginPage = location.pathname === '/login';
  const isHomePage = location.pathname === '/';
  const isKartu = location.pathname === '/kartu';

  return (
    <div>      
      {!isLoginPage && !isHomePage && <Header title={title} />}
      {!isLoginPage && !isHomePage && !isKartu &&  (
        <SubHeader title={subtitle} setDateRange={setDateRange} />
      )}
      <main className="main_wrap">
        {React.cloneElement(children, { dateRange }) /* Pass range to children */}
      </main>
      {!isLoginPage && <Footer />}
    </div>
  );
};


export default Layout;
